/**
 * Call Session Atoms - State management for Call Sessions (Read-only)
 *
 * Call Sessions = Scheduled call sessions for follow-ups
 * Read-only from call_sessions table
 *
 * NO LOCAL TYPES - All types come from @/isomorphic/schemas
 *
 * NOTE: All action functions have been moved to actions/call-session-actions.ts
 * This file now only contains atom definitions (state)
 */

import { atom } from "jotai";
import type { CallSession } from "@/isomorphic/schemas";
import type { AtomStatus, AtomError } from "@/frontend/types/atoms";

// ============================================================================
// ATOMS
// ============================================================================

/**
 * Internal atom: Follow-up call sessions (from API)
 * Exported for use in action functions
 */
export const _apiFollowUpCallSessionsAtom = atom<CallSession[]>([]);

export const followUpCallSessionsStatusAtom = atom<AtomStatus>("init");
export const followUpCallSessionsErrorAtom = atom<AtomError>(null);
export const currentCallSessionAtom = atom<CallSession | null>(null);
export const currentCallSessionStatusAtom = atom<AtomStatus>("init");

/**
 * Public atom: Follow-up call sessions
 */
export const followUpCallSessionsAtom = atom<CallSession[]>((get) => {
  return get(_apiFollowUpCallSessionsAtom);
});
